var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyIssuesClicked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.1 24.1",
    style: {
      enableBackground: "new 0 0 23.1 24.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.2,10.5c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5c-1.4,0-2.5,1.1-2.5,2.5S15.8,10.5,17.2,10.5z M17.2,11.4 c1.9,0,3.4-1.5,3.4-3.4s-1.5-3.4-3.4-3.4c-1.9,0-3.4,1.5-3.4,3.4S15.4,11.4,17.2,11.4z M9.6,18.1l-1.3,1.3l2.1,2.1L7.9,24l-2.1-2.1 l-1.6,1.6c-0.7,0.7-1.9,0.7-2.6,0l0,0C1,22.8,1,21.7,1.7,21L12,10.7C11.5,9.9,11.3,9,11.3,8c0-3.3,2.6-5.9,5.9-5.9s5.9,2.6,5.9,5.9 s-2.6,5.9-5.9,5.9c-1,0-1.9-0.2-2.7-0.7l-2.4,2.4l1.7,1.7l-2.5,2.5L9.6,18.1z M13,10.8C12.5,10,12.1,9,12.1,8 c0-2.8,2.3-5.1,5.1-5.1s5.1,2.3,5.1,5.1s-2.3,5.1-5.1,5.1c-1.1,0-2-0.3-2.9-0.9l-3.4,3.5l1.7,1.7l-1.3,1.3l-1.7-1.7l-2.5,2.5 l2.1,2.1l-1.3,1.3l-2.1-2.1l-2.2,2.2c-0.4,0.4-0.9,0.4-1.3,0l0,0c-0.4-0.4-0.4-1,0-1.3L13,10.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "7.5,3.2 9.2,4.9 9.9,4.2 8.2,2.5 9.9,0.7 9.2,0 7.5,1.8 5.7,0 5,0.7 6.8,2.5 5,4.2 5.7,4.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "2.5,10.2 4.2,11.9 4.9,11.2 3.2,9.5 4.9,7.7 4.2,7 2.5,8.8 0.7,7 0,7.7 1.8,9.5 0,11.2 0.7,11.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "19.5,21.2 17.7,23 17,22.2 18.8,20.5 17,18.7 17.7,18 19.5,19.8 21.2,18 22,18.7 20.2,20.5 22,22.2  21.2,23  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIssuesClicked);
export default __webpack_public_path__ + "static/media/key_issues_clicked.93a951d57704c54073e6681fe244f0a6.svg";
export { ForwardRef as ReactComponent };